import {
  Banner,
  Button,
  ButtonGroup,
  Modal,
  TextStyle
} from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import envConfig from '@nile/home/src/Config/env';

const PerplexityConfirmationModal = ({
  open,
  onClose,
  onCancel,
  onConfirm
}) => {
  const onEnable = () => {
    onConfirm();
  };

  const redirectToPerplexity = () => {
    window.open(
      'https://www.perplexity.ai/hub/legal/terms-of-service',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const redirectToSuperOpsTerms = () => {
    window.open(
      'https://www.perplexity.ai/hub/legal/terms-of-service',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Modal
      variant="info"
      open={open}
      showCloseButton={false}
      onClose={onClose}
      title={<FormattedMessage id="msp.ai.settings.enable.web.search" />}
      noScroll
    >
      <Modal.Section>
        <div>
          <TextStyle>
            <FormattedMessage
              id="admin.ai.perplexity.information.message"
              values={{
                link: (
                  <span
                    className="underline pointer"
                    onClick={redirectToPerplexity}
                  >
                    <FormattedMessage id="admin.EmailServerSettings.msp.banner.here" />
                  </span>
                )
              }}
            />
          </TextStyle>
        </div>

        <div className="mt10">
          <TextStyle>
            <FormattedMessage
              id="admin.terms.services.updated.message"
              values={{
                link: (
                  <span
                    className="underline ml-5 pointer"
                    onClick={redirectToSuperOpsTerms}
                  >
                    <FormattedMessage id="admin.EmailServerSettings.msp.banner.here" />
                  </span>
                )
              }}
            />
          </TextStyle>
        </div>
        <div className="perplexity-img mt15">
          <img
            src={`${envConfig.imageRoot}png/perplexity-web-search.png`}
            alt="perplexity-ai-web-search"
            className="w100"
          />
        </div>
        <div className="mt15">
          <Banner status="warning">
            <TextStyle weight="Medium">
              <FormattedMessage id="admin.ai.perplexity.warning.message" />
            </TextStyle>
          </Banner>
        </div>

        <div className="mt10 flex jend">
          <ButtonGroup>
            <Button plainSecondary onClick={onCancel}>
              <FormattedMessage id="common.no.dont.continue" />
            </Button>

            <Button primary onClick={onEnable}>
              <FormattedMessage id="common.yes.continue" />
            </Button>
          </ButtonGroup>
        </div>
      </Modal.Section>
    </Modal>
  );
};

export default PerplexityConfirmationModal;
